import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { getInstitutionById } from "../../api/Institution/InstitutionApi";
import { getRequest, saveRequest } from "../../api/Request/RequestApi";
import { useAppDispatch } from "../../app/store";
import {
  ContentArea,
  ToolbarTop,
  ToolbarEdit,
  RequestHeader,
} from "../../components";
import { ValidationFailure } from "../../models";
import { InstitutionData } from "./RequestComponents/InstitutionData";
import { Institution } from "../../models/Institution";
import { Request, RequestStatus, RequestType } from "../../models/Request";
import { requestAdminDetailsUrl } from "../../routes/routes";
import { resetIsEdited, setIsEdited } from "../../slices/applicationSlice";

export function RequestInstitutionEdit() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const createDefault = (): Request => {
    return {
      id: 0,
      requestUID: "",
      code: "",
      statusId: RequestStatus.Draft,
      schoolYearId: 0,
      type: RequestType.RegularEnrollment,
      createdByAdmin: true,
      isOutsideEnrollmentArea: false,
      step: 0,
      subStep: 0,
      parentRemark: null,
    };
  };
  const [item, setItem] = useState<Request>(createDefault());
  const [primaryInstitution, setPrimaryInstitution] = useState<
    Institution | undefined
  >();

  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [errors, setErrors] = useState<ValidationFailure[]>();

  useEffect(() => {
    (async () => {
      setIsEditing(true); // Assume we don't get one.
      if (id && id !== "0") {
        var request = await getRequest(+id);
        if (request) {
          setItem(request);
        }
      }
    })();
    dispatch(resetIsEdited());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  useEffect(() => {
    (async () => {
      if (
        item.institutionId &&
        item.schoolYearId > 0 &&
        (!primaryInstitution || primaryInstitution.id !== item.institutionId)
      ) {
        const inst = await getInstitutionById(
          item.institutionId,
          item.schoolYearId
        );
        if (inst) setPrimaryInstitution(inst);
      }
    })();
  }, [item.institutionId, item.schoolYearId]);

  const handleUpdate = (item: Request) => {
    setItem(item);
    dispatch(setIsEdited());
  };

  return (
    <ContentArea>
      <ToolbarTop
        showAdd={"hide"}
        showBack={"show"}
        pageTitle={t("request.selectInstitutionData")}
        errors={errors}
      />
      <RequestHeader request={item} />
      {item.id !== 0 && (
        <InstitutionData
          item={item}
          primaryInstitution={primaryInstitution}
          handleUpdate={handleUpdate}
          errors={errors}
        />
      )}
      <ToolbarEdit
        showCancel={"show"}
        showSave={isEditing ? "show" : "hide"}
        redirectUrlSaveOK={() => requestAdminDetailsUrl(+id)}
        handleSave={async () => saveRequest(item)}
        setSaveErrors={setErrors}
        showCustom={false}
      />
    </ContentArea>
  );
}
